<template>
  <div>
    <t-field>
      <div class="text-sm font-bold pb-2">How often will the spell be invoked?</div>
      <t-rads v-model="freq" :opts="[
                             {name: 'Daily', value: 'DAILY'},
                             // {name: 'Weekdays', value: 'WEEKDAYS'},
                             {name: 'Weekly', value: 'WEEKLY'},
                             {name: 'Monthly', value: 'MONTHLY'},
                             {name: 'Yearly', value: 'YEARLY'}
                             ]" />
    </t-field>
    <t-field>
      <div class="text-sm font-bold pb-2">When should it start?</div>
      <div class="text-xs pb-4">The time and day of the week, month or year is derived from this setting.</div>
      <input type="datetime-local"
        v-model="ts"
        class="form-control bg-white py-3 px-4 text-sm font-mono"
        name="meeting-time">

    </t-field>
  </div>
</template>

<script>
 import { DateTime } from 'luxon';

 export default {
   props: {
     spellKind: {
       type: String,
       required: true,
     },
     value: {
       type: Object,
       default: () => ({})
     }
   },

   data () {
     return {
       ts: DateTime.fromISO(this.value.timestamp).toFormat('yyyy-LL-dd\'T\'HH:mm'),
       freq: this.value.freq,
     }
   },

   watch: {
     ts (to) {
       this.$emit('input',
                  {
                    timestamp: to,
                    freq: this.freq
       })
     },
     freq (to) {
       this.$emit('input',
                  {
                    timestamp: this.ts,
                    freq: to
       })
     }
   }
 }



</script>
